import * as types from '../actions/actionTypes';

const initialState = {
  priceWorksheetOpened: false,
  discountsReceived: false,
  discountSections: []
};

export default function(state = initialState, action) {

  switch(action.type) {

    case types.TOGGLE_PRICE_WORKSHEET_OPENED:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_DISCOUNT_SECTIONS:
      return Object.assign({}, state, {
        ...action.payload,
        discountsReceived: true
      });
  }

  return state;
}
